module.exports = __webpack_public_path__ + "static/media/emptying.69cc2237.mp4";